<template>
  <div class="report-info">
    <pdf-view
      :pdf-b64="receivedPDF"
      pdf-file-name="apreport.pdf"
    />
    <div
      v-if="error"
      class="text-center my-3"
    >
      <small>{{ $t('global.noReport') }}</small>
    </div>
    <div
      v-if="busy"
      class="spinner-wrapper"
    >
      <vt-loading />
    </div>
  </div>
</template>

<script>

import clinicalCasePrintService from '@/modules/printModule/services/ClinicalCasePrintService'
import PdfView from '@/components/pdf-view/pdf-view.vue'

export default {
    name: 'ReportInfo',
    components: {
        PdfView
    },
    props: {
        casId: { type: Number, required: true },
        labId: { type: Number, required: true }
    },
    data() {
        return {
            busy: false,
            error: false,
            receivedPDF: null
        }
    },
    watch: {
        casId: function() {
            this.loadPdfReport()
        }
    },
    created() {
        this.loadPdfReport()
    },
    methods: {
        async loadPdfReport() {
            this.busy = true
            this.error = false
            // TODO: Israel - Ahora mismo se pone false, hablar con pablo y fernando para
            // ver cómo indicar al usuario si quiere que se impriman los informes de casos
            // asociados (true) o no (false)
            const [err, response] = await this.toCall(clinicalCasePrintService.getCaseAPReportPdfForPrinting(this.labId, this.casId, false))
            this.busy = false
            if (err) {
                this.error = true
                return
            }
            this.$emit('loadSummary')
            this.receivedPDF = response
        }
    }
}

</script>

<style lang="scss">
  .report-info span {
    display: block !important;
  }
</style>
